import SectionB1EU from 'elem/compPage/stream-series-plug-in-solar-battery/pages/product/components/SectionB1';

const SectionB1: React.FC = () => {
    return <SectionB1EU />;
};

export default SectionB1;
